export default __webpack_public_path__ + "static/media/A360-Badge-White-on-Black.28e7ccd7.svg";